import React, { useState, useRef, useEffect } from 'react';
import loadingImage from './loading.avif';
import loadingAudio from './loading.mp3';
import './LoadingScreen.css';

// Length of the loading animation in milliseconds
const ANIMATION_DURATION = 5000;

export default function LoadingScreen({ onFinish }) {
  const [canAutoplay, setCanAutoplay] = useState(false);
  const [readyToStart, setReadyToStart] = useState(false);
  const audioRef = useRef();
  const timerRef = useRef();

  // 1) Test autoplay capability on mount
  useEffect(() => {
    const testAudio = document.createElement('audio');
    testAudio.src = loadingAudio;
    testAudio.muted = false;
    testAudio.play()
      .then(() => {
        setCanAutoplay(true);
        testAudio.pause();
      })
      .catch(() => {
        setCanAutoplay(false);
      });
  }, []);

  // 2) Once we know autoplay is allowed (or not), we can show the image and start.
  //    We delay starting both audio & timer until the img is loaded *and*
  //    either autoplay is allowed (so we can play audio) *or* we give up on audio.
  const handleImgLoad = () => {
    setReadyToStart(true);
  };

  useEffect(() => {
    if (!readyToStart) return;

    // If we can autoplay, start the real audio
    if (canAutoplay && audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch(() => {/* swallow */ });
    }
    // Start the AVIF timer
    timerRef.current = setTimeout(onFinish, ANIMATION_DURATION);

    return () => clearTimeout(timerRef.current);
  }, [readyToStart, canAutoplay, onFinish]);

  return (
    <div className="loading-screen">
      {canAutoplay && (
        <audio
          ref={audioRef}
          src={loadingAudio}
          preload="auto"
        />
      )}
      <div className="crt-frame">
        <div className="crt-screen">
          <img
            src={loadingImage}
            alt="Loading…"
            onLoad={handleImgLoad}
            // style={{ opacity: readyToStart ? 1 : 0.5 }}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
          <div className="crt-scanlines"></div>
        </div>
      </div>
    </div>
  );
}